<script>
import i18n from "../i18n";
import { menuItems } from "./horizontal-menu";
import { anonymousMenuItems } from "./anonymous-Menu-Items";
import Cart from "@/router/views/order/cart.vue"
import CartApi from "@/services/cart-api";
import CartSummary from "../router/views/order/cartSummary.vue"

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}
 

/**
 * Nav-bar Component
 */
export default {
  components:{Cart , CartSummary},
  computed: {

    isShowSpinner() {
        return this.$store.state.isLoadingCart;
      },

    cartCount() {
      let cart = this.$store.state.cart;
      return cart && cart.lines && cart.lines.list ? cart.lines.list.length : 0;
    },
    
    permission() {
         const  storedPermissions = JSON.parse(getCookie('permission')) || [];
        return storedPermissions
        },

    notifPagesNbr() {
      return Math.ceil(this.notificationsCount / this.notifPageSize);
    },

    userShortName() {
      var short = this.$cookies.get('userFullName') /* this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName').split(' ')[0] : ''*/;      
      return short.length > 7 ? short.substring(0, 7) + '...' : short;
    },

    userFirstName() {
      const fullName = this.$cookies.get('userFullName');
      if (!fullName) return '';

      return fullName.trim().split(' ')[0];
    },


    userFullName() {
      return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
    },

    companyName() {
      return this.$cookies.isKey('companyName') ? this.$cookies.get('companyName').length > 10 ? this.$cookies.get('companyName').substring(0, 10) + '...' : this.$cookies.get('companyName') : '';   
    },

    fullCompanyName() {
      return this.$cookies.isKey('companyName') ? this.$cookies.get('companyName') : '';   
    },

    isSupplier() {
      return this.$cookies.get('userr') == 1;
    },

    isAdmin() {
      return this.$cookies.get('userr') == 2;
    },

    role() {
      return this.$cookies.get('userr');
    },

    draftOrderId() {
      return this.$cookies.isKey('drafto') ? this.$cookies.get('drafto') : null;
    },

    draftOrderLinesCount() {
      return this.$cookies.isKey('draftoc') ? this.$cookies.get('draftoc') : null;
    },
    
    

  },
  data() {
    return {
      languages: [
        {
          language: "fr",
          title: "French",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,

      keyword:"",
      supplierFullName:'',

      interval: null,

      notifications: [],
      notificationsCount: 0,
      notifPage: 1,
      notifPageSize: 3,

      selectedUserList:[],
      showUsersModal:false,

      showDraftOrder: false,

      menuItems: menuItems,
      anonymousMenuItems: anonymousMenuItems,
      countLastRequestQuote: null,
      isScrolled:false,
      cart:null,
      deliveryModes: [],

    };
  },

  created() {
    },
    beforeDestroy () {
      clearInterval(this.interval);
    },


  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    this.getDeliveryModes();

    window.addEventListener('scroll', this.handleScroll);

    this.$root.$on('order-changed-event', () => {
        this.$cookies.refresh()
    })

    this.$root.$on('order-submitted', () => {
        this.$cookies.refresh()
    })

    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;

  },
  methods: {

    fetchCart() {
        this.$store.dispatch('fetchCart');
      },

    getDeliveryModes() {
      CartApi.getDeliveryModes().then(
        (deliveryModes)=> {
          this.deliveryModes = deliveryModes;
        }
      ).finally(() => {
        
      });
    },

    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },

    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country) {
      this.lan = locale;
      this.text = country;
      i18n.locale = locale;
    },

    toNotificationIcon(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "fas fa-dolly";
        case 1: return "fas fa-check-double";
        case 2: return "fas fa-truck-loading";
        case 3: return "fas fa-exclamation-triangle";
        case 4 : return "fas fa-file-invoice-dollar";
        default : return "fas fa-dolly";
      }
    },

    toNotificationColor(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "bg-danger";
        case 1: return "bg-info";
        case 2: return "bg-success";
        case 3: return "bg-secondary";
        case 4: return "bg-primary";
        default : return "bg-secondary";
      }
    },

    toPath(notificationType){
      if (notificationType == null) {
        return;
      }
      if(notificationType==0 || notificationType==1 || notificationType==2 || notificationType==3){
        return '/orders/order'
      }
    },

    toQuery(notif){
      if (notif == null) {
        return;
      }
      if(notif.type==0 || notif.type==1 || notif.type==2 || notif.type==3){
        return notif.orderId
      }

      if(notif.type==4){
        return null
      }
    },

    connect() {
      if(!this.userFullName) {
        this.$router.push({ name: "login" });
      }
    },

    onDraftModalClose() {
      this.$root.$emit('order-cart-modal-closed', true)
    },

    

  },

  watch :{

    '$store.state.cart': {
        handler(newCart) {
            this.cart = newCart;
        },
        deep: true,
    },


    '$route.query.filter': {
        handler: function(filter) {
          this.keyword = filter;
        },
        deep: true,
        immediate: true
    },

    role: function() {
  
    },


    

    
  }

  


};
</script>

<style>
  /* .navbar-header .dropdown.show .header-item {
    background-color: #5cb45b;
} */

    .navbar-header .mobile-user-button .dropdown .dropdown-menu {
        left: 0px !important;
        top: 65px !important;
        min-width: 100vw;
    }

    @media all and (max-width: 1024px) and (min-width: 1024px) {
    #logo {
        padding-left: 20px;
    } 

    }


  
    .menu {
      overflow-x: scroll;
      overflow-y: hidden; 
      white-space: nowrap;
      width: 100%;
      height: 100%; 
      -ms-overflow-style: none; 
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
    }

    .menu::-webkit-scrollbar {
      display: none; /* hide scrollbar on Chrome and Safari */
    }

    .menu:active {
      cursor: grab;
      cursor: -webkit-grab;
    }

    .menu:active::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }

    .menu:active::-webkit-scrollbar-track {
      background-color: #f1f1f1;
    }

    .menu ul {
      display: flex; /* use flexbox to make menu items expand to fill available space */
      align-items: stretch; /* stretch menu items to the full height of the menu */
    }

    .menu li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /*border-bottom: 3px solid white;*/
  /*border-top: 3px solid white;*/
  cursor: pointer;
  position: relative;
}

/* .menu li a:hover {
  color: #00acc8 !important;
} */

.menu li.active a,

.menu li.active,
.menu li:hover {
  /*border-bottom: 3px solid #2E469D ;*/
  color: #2E469D  !important;
}

.menu_title {
  color: white !important;
  text-shadow: 
    2px 2px 4px rgba(29, 185, 100, 0.5), 
    -2px -2px 6px rgba(0, 255, 255, 0.8);
}


.menu_title:hover {
  /*background-color: #ddd;*/
  color: #cfcece !important;
}


.menu li a {
  display: flex; /* enable flexbox layout */
  align-items: center; /* center link content vertically */
  justify-content: center; /* center link content horizontally */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-decoration: none;

  color: #333;
  text-decoration: none;
      font-size: 14px;
      font-weight: bold;
}

menu ul {
      display: inline-block;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

  

</style>

<template>  
<div :class="$route.name != 'default'  ? 'navbar-header' : '' "  >
 
  <header id="page-topbar"  >

    <!-- LOGO BLOCK & MOBILE MENU BUTTON -->
    <div class="navbar-header" :class="{ 'scroll-header': isScrolled }"  >

      <div class="row w-100 m-sm-4 m-0 " >

        <div class="col-1 col-md-6 col-lg-2 col-xl-2 col-xxl-3" style="z-index:10000">
            <div class="d-flex mobile-user-button">

              <!-- MAIN LOGO -->
              <div class="my-auto" >
                <router-link to="/" class="logo logo-light  " id="logo" >
                  <span class="logo-sm">
                    <img class="ml-2" 
                    :src="($route.name == 'default' && !isScrolled) ? require('@/assets/images/logo.png') : require('@/assets/images/logo.png')" 
                          alt height="60"  />
                  </span>
                  <span class="logo-lg">
                    <img 
                    :src="($route.name == 'default' && !isScrolled) ? require('@/assets/images/logo.png') : require('@/assets/images/logo.png')" 
                    alt :height="($route.name == 'default' && !isScrolled) ? 60 : 60 " />
                  </span>
                </router-link>
              </div>

              <b-dropdown  v-if="!userFullName" right variant="black" toggle-class="noti-icon" class=" my-auto d-block d-lg-none "  >
                    <template v-slot:button-content>
                      <img class="my-auto" :src="($route.name == 'default' && !isScrolled) ? require('@/assets/icons/menu-white.svg') : require('@/assets/icons/menu.svg')" alt height="35" />
                    </template>
      
                    <div class="menu-mobile">
                      
                      <ul style="margin: 0; height: 100%;">
                        <template v-for="(item, index) in anonymousMenuItems">
                          <li
                            :class="$route.name !== 'default' && $route.path === item.link ? 'active' : ''" 
                            :key="index"
                            role="menuitem"
                          >
                            <router-link
                              class="text-uppercase d-block w-100 font-size-12"
                              :to="item.link"
                              role="button"
                              @click="onMenuClick($event)"
                            >
                              {{ $t(item.label) }}
                            </router-link>
                          </li>
                        </template>
                      </ul>
                    </div>

                  <b-dropdown-divider v-if="userFullName && isSupplier"></b-dropdown-divider>

              </b-dropdown>

              
            </div>
            
        </div>

        <div class="col-0 col-md-0 col-lg-8 col-xl-8 col-xxl-6 d-none d-lg-block my-auto" style="margin-top: 0px !important;margin-bottom: 0px !important;">

              <div class="my-auto" style="height:100%;" >
                  
              
                <div class="menu">
                <!--ul  v-if="userFullName" style="height:100%;"> 
                    <template v-for="(item, index) of menuItems" > 
                        <li :class="$route.name != 'default' && $route.path == item.link ?  'active' : ''" :key="index"  v-if=" role == null ? item.role==0  : 
                        (item.role==role && !item.onlyPartner && ( permission && permission.some(pr=> item.subRole!=null ? item.subRole.includes(pr) :true )  || item.subRole==null )  )  " >
                          <router-link
                            class="text-dark mr-4 ml-4" 
                            :to="item.link"
                            role="button"
                            @click="onMenuClick($event)" 
                            >
                            {{ $t(item.label) }}
                            <span 
                                v-if="item.link == '/demande/devis' && countLastRequestQuote" 
                                class="badge text-white d-flex align-items-center justify-content-center ml-1 mb-2"
                                :class="[
                                  countLastRequestQuote == 0 ? 'd-none' : '',
                                  'circular-badge font-weight-bold font-size-12 bg-danger'
                                ]"
                              >
                                {{ countLastRequestQuote > 99 ? '+99' : countLastRequestQuote }}
                              </span>

                          </router-link>
                        </li>
                    </template>
                  </ul-->
                  
                  <ul style="margin: 0; height: 100%;">
                    <template >
                      <li v-for="(item, index) in anonymousMenuItems"
                        :class="$route.name !== 'default' && $route.path === item.link ? 'active' : ''"  :key="index"
                      >

                      <!-- role="menuitem"
                          aria-current="$route.path === item.link ? 'page' : null" -->
                        <router-link
                          class="text-uppercase"
                          :class="$route.name == 'default' && !isScrolled ? 'text-white ' : 'text-dark'"

                          :to="item.link"
                          role="button"
                          @click="onMenuClick($event)"
                        >
                         {{ $t(item.label) }}
                        </router-link>
                      </li>
                    </template>

                  </ul>


                </div>




                

              </div>

        </div>

        <div class="col-11 col-md-6 col-lg-2 col-xl-2 col-xxl-3 d-flex justify-content-end align-items-center my-auto">
              <!-- NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON -->
              <div class="d-flex align-items-center">

                  
                  <div class="dropdown b-dropdown btn-group mr-2"  v-b-toggle.sidebar-backdrop @click=" fetchCart()">
                      <button type="button" class="btn header-item noti-icon right-bar-toggle toggle-right p-0 pr-1 m-0"  >
                        <img height="32px" :src="($route.name == 'default' && !isScrolled) ? require('@/assets/icons/cart-white.svg') : require('@/assets/icons/cart.svg')" />
                        <span class="badge badge-light font-weight-bold font-size-12 " 
                          :class="cartCount == 0 ? 'd-none' : ''">
                          {{ cartCount }}
                        </span>
                      </button>
                  </div>
                                    <!-- LEFT USER BUTTON -->
                  <b-dropdown v-if="userFullName" right variant="black" toggle-class="header-item noti-icon" >
                    <template v-slot:button-content class="bg-danger">


                      <!-- <div class="row d-none d-sm-flex" @click=" connect()"  > -->
                        <!-- border: 2px solid #00acc8 -->
                        <!-- d-none d-sm-flex -->
                    <div class=" espace-client-link col-xl-12 col-lg-12 text-left " >
                      <span class="p-2 d-flex align-items-center">
                          {{userFirstName}}
                          <img height="25px" class="ml-1" src="@/assets/icons/menu.svg" />
                      </span>
                    </div>
                                
                    </template>

                        <a v-if="!userFullName" href="/se-connecter" class="dropdown-item w-100 p-md-2 p-2" >
                              <h5 class="text-primary font-weight-bold"> <img   alt=""  width="17px" class="mr-1"  src="@/assets/icons/user.svg"  />Espace client</h5>
                              <span class="text-primary ">
                                Si vous avez déjà un compte ?
                              </span>
                        </a>

                        <a v-if="userFullName" href="/" class="dropdown-item text-dark" >
                          <img  alt="home"  width="20px" class="mr-2"  src="@/assets/icons/home.svg" style="cursor: pointer;"  />
                              {{ $t('dropDown.home.text') }}                     
                        </a>

                        <b-dropdown-divider v-if="userFullName && isSupplier"></b-dropdown-divider>

                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>

                        <a v-if="userFullName" href="/commandes" class="dropdown-item text-dark" >
                          <img  alt="user"  width="20px" class="mr-2"  src="@/assets/icons/order.svg" style="cursor: pointer;"  />
                            {{ $t('dropDown.order.text') }}
                        </a>

                        <a v-if="userFullName" href="/profil" class="dropdown-item text-dark" >
                          <img  alt="user"  width="20px" class="mr-2"  src="@/assets/icons/user-alt.svg" style="cursor: pointer;"  />
                            {{ $t('dropDown.profil.text') }} {{this.userFullName}}
                        </a>

                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>

                        <a v-if="userFullName" href="/logout" class="dropdown-item text-danger font-weight-bold" >
                          <img  alt="sign-out"  width="20px" class="mr-2"  src="@/assets/icons/sign-out.svg" style="cursor: pointer;"  />
                            {{ $t('dropDown.logOut.text') }}
                        </a>

                  </b-dropdown>
                  <!--span v-else>
                    <a href="/se-connecter" class="header-item">
                      <span class="p-2 d-flex align-items-center">
                        <img height="25px"  class="mb-1 mr-1"  :src="($route.name == 'default' && !isScrolled) ? require('@/assets/icons/user-white.svg') : require('@/assets/icons/user.svg')" />
                      </span>
                    </a>
                  </span-->

                <div>
                  <b-sidebar
                   style="z-index: 10001;"
                    id="sidebar-backdrop"
                    title="Panier"
                    aria-labelledby="sidebar-no-header-title" 
                    width="400px"
                    bg-variant="white"
                    backdrop
                    shadow no-header
                  >
                 
                  <div class="d-flex justify-content-between align-items-center p-2">
                    <span class="m-0 font-size-24 font-weight-bold mx-auto">Panier</span>
                    <img v-b-toggle.sidebar-backdrop src="@/assets/icons/close-x.svg" height="17" class="ms-auto" />
                  </div>

                  

                  <template #footer>
                    <div class="d-flex align-items-center px-3 py-2">
                      <CartSummary v-if="!isShowSpinner && cart" :cart="cart" :deliveryModes="deliveryModes"  ></CartSummary>
                    </div>
                  </template>
                
                    <div class="px-3 py-2">
                      <Cart />
                    </div>
                  </b-sidebar>
              </div>

              </div>
              <!-- END NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON  -->
        </div>


      </div>

    </div>

  </header>

</div>

</template>


<style scoped>
.pageTitle {
  font-size: 44px;
  letter-spacing: -1px;
  line-height: 58px;
  font-weight: 500;
  color: #121212;
}

.menu-mobile {
  width: 100%;
  background-color: #fff; 
  position: fixed;
  top: 0;
  z-index: 1000; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: block;
    flex-direction: column; 
    justify-content: space-between;
    height: 100%;

    li {
      padding: 15px 20px;
      text-align: left;
      font-size: 1rem;
      transition: background-color 0.3s ease, color 0.3s ease;

      &.active {
        background-color: #f0f0f0;
        font-weight: bold;
        border-left: 4px solid #2E469D ;
      }

      &:hover {
        background-color: #e9ecef;
      }

      .text-dark {
        color: #333;
        text-decoration: none;
      }

      .text-uppercase {
        text-transform: uppercase; 
      }
    }
  }

  a {
    color: inherit; 
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: 768px) {
    ul {
      flex-direction: row; 
    }

    li {
      padding: 10px 15px; 
    }
  }
}

.circular-badge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
}


</style>

<style scoped>

.espace-client-link {
  display: inline-block;
  border-radius: 12px; 
  background: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease-in-out;
  font-weight: bold;
  text-decoration: none;
}

.espace-client-link span {
  color: #121212;
  font-size: 14px;
  font-weight: bold;
}

.espace-client-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.25);
  background: linear-gradient(145deg, #f9f9f9, #e6e6e6);
}


::v-deep .navbar-header .dropdown.show .header-item {
  background-color: transparent !important;
}
</style>